import React from "react";
const BiHelpersContext = React.createContext({});
const BiHelpersProvider = ({ children, helpers }) => {
  return /* @__PURE__ */ React.createElement(BiHelpersContext.Provider, { value: helpers }, children);
};
const useBiCallbacks = () => {
  return React.useContext(BiHelpersContext);
};
export {
  BiHelpersProvider,
  useBiCallbacks
};
//# sourceMappingURL=bi-helpers-context.js.map
